import React, {Component} from 'react';

import InputMask from 'react-input-mask';

import Datepicker from "../../../../components/Datepicker/datepicker";
import PlateInput from "../../../../components/PlateInput/plateInput";

export default class ProgrammingForm extends Component {

    componentDidMount(){
        window.initializeCollapsible();
        window.initializeSelects('body');
        window.bindSelectAction(this.productSelect, this.props.handleSelect);
        window.bindSelectAction(this.terminalSelect, this.props.handleSelect);
        window.bindSelectAction(this.operationSelect, this.props.handleSelect);
        window.bindSelectAction(this.areaSelect, this.props.handleSelect);
    }


    render() {
        let date = new Date();
        let maxDate = new Date(date.setTime(date.getTime() + (24*60*60*1000*90)));
        let minDate = new Date();

        return (
            <div className={"row no-padding thin-row trip-form"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Transporte</h4>
                    </div>
                    <div className={"row margin-top-10"}>
                        <div className={"col s12 input-field input-grey"}>
                            <label className="active">Empresa Transportista</label>
                            <input placeholder={"Ingrese empresa"} value={this.props.state.carrier}
                                   onChange={(ev) => this.props.handleInput('carrier', ev.target.value)}
                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Patente Chasis</label>
                            <PlateInput
                                placeholder="Ingrese patente del chasis" value={this.props.state.truck_plate}
                                action={this.props.handleInput} name={'truck_plate'}
                            />
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Patente Acoplado</label>
                            <PlateInput
                                placeholder="Ingrese patente del acoplado" value={this.props.state.trailer_plate}
                                action={this.props.handleInput} name={'trailer_plate'}
                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Chofer - Nombre y Apellido</label>
                            <input placeholder={"Ingrese nombre del chofer"} value={this.props.state.driver_name}
                                   onChange={(ev) => this.props.handleInput('driver_name', ev.target.value)}
                            />
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Licencia de Conducir</label>
                            <input placeholder={"Ingrese licencia"} value={this.props.state.driver_doc}
                                   onChange={(ev) => this.props.handleInput('driver_doc', ev.target.value)}/>
                        </div>
                    </div>
                    <div className={"row no-margin"}>
                        <div className={"col s12 input-field input-grey"}>
                            <label className="active">Observaciones</label>
                            <input placeholder={""} value={this.props.state.business_observations}
                                   onChange={(ev) => this.props.handleInput('business_observations', ev.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Operación</h4>
                    </div>
                    <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field"}>
                                <label className="active">Tipo de Operación</label>
                                <select defaultValue={this.props.state.operation_type}
                                        data-state-var="operation_type" ref={ref => {this.operationSelect = ref}}>
                                    <option value="">Seleccione la operación</option>
                                    {this.props.state.operation_types && this.props.state.operation_types.map(ot => {
                                        return <option key={ot.id} id={ot.id}
                                                       value={ot.id}>{ot.value}</option>
                                    })}
                                </select>
                            </div>
                            <div className={"col s6 input-field "}>
                                <label className="active">Fecha estimada de Carga/Descarga</label>
                                <Datepicker classname="input-grey" placeholder={"Ingrese fecha"} max={maxDate} min={minDate}
                                            value={this.props.state.estimated_load_date} format={"YYYY-MM-DD"}
                                            id="estimated_load_date" action={this.props.handleDate} />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field"}>
                                <label className="active">Producto</label>
                                <select defaultValue={this.props.state.product}
                                        data-state-var="product"  ref={ref => {this.productSelect = ref}}>
                                    <option value="">Seleccione producto</option>
                                    {this.props.state.products && this.props.state.products.map(product => {
                                        return <option key={product.id} id={product.id}
                                                       value={product.id}>{product.name}</option>
                                    })}
                                </select>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Destino</label>
                                <select defaultValue={this.props.state.terminal}
                                        data-state-var="terminal"  ref={ref => {this.terminalSelect = ref}}>
                                    <option value="">Seleccione destino</option>
                                    {this.props.state.terminals && this.props.state.terminals.map(terminal => {
                                        return <option key={terminal.id} id={terminal.id}
                                                       value={terminal.id}>{terminal.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field"}>
                                <label className="active">Area de carga/descarga</label>
                                <select defaultValue={this.props.state.destination_area}
                                        data-state-var="destination_area" ref={ref => {this.areaSelect = ref}}>
                                    <option value="">Seleccione un area de carga/descarga</option>
                                    {this.props.state.destination_areas && this.props.state.destination_areas.map(area => {
                                        return <option key={area.id} id={area.id}
                                                       value={area.id}>{area.name}</option>
                                    })}
                                </select>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Contacto</label>
                                <input placeholder={"Ingrese el nombre y apellido del contacto"}
                                       value={this.props.state.contact}
                                       onChange={(ev) => this.props.handleInput('contact', ev.target.value)}
                                />
                            </div>
                        </div>
                        <div className={"row no-margin"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Remito Contratista</label>
                                <InputMask placeholder={"Ingrese el número del remito"}
                                           value={this.props.state.provider_trip_receipt} mask={'9999-99999999'}
                                           onChange={(ev) => this.props.handleInput('provider_trip_receipt', ev.target.value)}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Remito Shell</label>
                                <InputMask placeholder={"Ingrese el número del remito"}
                                           value={this.props.state.shell_trip_receipt} mask={'9999-99999999'}
                                           onChange={(ev) => this.props.handleInput('shell_trip_receipt', ev.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/newTrip/ProgrammingForm.js